var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 473,
    height: 546,
    viewBox: "0 0 473 546",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 62.5,
    y1: 2.18557e-8,
    x2: 62.5,
    y2: 546,
    stroke: "white",
    strokeOpacity: 0.3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 146.5,
    y1: 2.18557e-8,
    x2: 146.5,
    y2: 546,
    stroke: "white",
    strokeOpacity: 0.3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 231.5,
    y1: 2.18557e-8,
    x2: 231.5,
    y2: 546,
    stroke: "white",
    strokeOpacity: 0.3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 312.5,
    y1: 2.18557e-8,
    x2: 312.5,
    y2: 546,
    stroke: "white",
    strokeOpacity: 0.3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 404.5,
    y1: 2.18557e-8,
    x2: 404.5,
    y2: 546,
    stroke: "white",
    strokeOpacity: 0.3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 506,
    y1: 102.5,
    x2: -40,
    y2: 102.5,
    stroke: "white",
    strokeOpacity: 0.3
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 506,
    y1: 186.5,
    x2: -40,
    y2: 186.5,
    stroke: "white",
    strokeOpacity: 0.3
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 506,
    y1: 271.5,
    x2: -40,
    y2: 271.5,
    stroke: "white",
    strokeOpacity: 0.3
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 506,
    y1: 352.5,
    x2: -40,
    y2: 352.5,
    stroke: "white",
    strokeOpacity: 0.3
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 506,
    y1: 444.5,
    x2: -40,
    y2: 444.5,
    stroke: "white",
    strokeOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.f55efa2549929d591e39b167af4514c5.svg";
export { ForwardRef as ReactComponent };